// hd-redesign-p1 — the mega menu, and the header's scrolled shadow.
//
// From the export: the panel opens on mouseenter of the trigger, stays open
// while the pointer is inside it, and closes 120ms after the pointer leaves the
// header. The grace period is the whole point — the pointer has to cross a gap
// between the trigger and the panel, and without it the menu shuts underneath
// the pointer on the way down.
//
// Two things the export does not do, added because a hover-only menu is
// unreachable otherwise: the panel also opens on keyboard focus entering the
// nav item, and Escape closes it and returns focus to the trigger.
//
// The trigger stays a real <a> to the products collection. In the export it is
// a button that scrolls to the offers anchor, which only exists on the home
// screen of a two-screen prototype; here the header is on every template, so
// the trigger has to lead somewhere real with JS off.
(function () {
  "use strict";

  var GRACE = 120;

  function init() {
    var header = document.querySelector(".hd-nav");
    if (!header) return;

    var trigger = header.querySelector("[data-mega-trigger]");
    var panel = header.querySelector("[data-mega]");
    var timer = null;

    if (trigger && panel) {
      var tabs = Array.prototype.slice.call(panel.querySelectorAll("[data-tab]"));
      var panes = Array.prototype.slice.call(panel.querySelectorAll("[data-tab-panel]"));

      var open = function () {
        window.clearTimeout(timer);
        panel.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
      };

      var close = function () {
        panel.hidden = true;
        trigger.setAttribute("aria-expanded", "false");
      };

      var closeSoon = function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(close, GRACE);
      };

      trigger.addEventListener("mouseenter", open);
      trigger.addEventListener("focus", open);
      panel.addEventListener("mouseenter", function () {
        window.clearTimeout(timer);
      });
      header.addEventListener("mouseleave", closeSoon);

      header.addEventListener("focusout", function (e) {
        if (!header.contains(e.relatedTarget)) close();
      });

      document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape" || panel.hidden) return;
        close();
        trigger.focus();
      });

      tabs.forEach(function (tab) {
        // A tab carrying an href is a link, not a tab — the export's "Offers"
        // entry navigates instead of switching, and it keeps that job here.
        if (tab.tagName === "A") return;
        tab.addEventListener("click", function () {
          var name = tab.getAttribute("data-tab");
          tabs.forEach(function (t) {
            if (t.tagName !== "A")
              t.setAttribute("aria-selected", t === tab ? "true" : "false");
          });
          panes.forEach(function (p) {
            p.hidden = p.getAttribute("data-tab-panel") !== name;
          });
        });
      });
    }

    // The shadow appears once scrolled. Threshold and value are the export's.
    var scrolled = false;
    function onScroll() {
      var s = window.scrollY > 10;
      if (s === scrolled) return;
      scrolled = s;
      header.classList.toggle("is-scrolled", s);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
